import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import "../../../i18n";
import SectionLabel from "../components/SectionLabel";
import PricingCard from "../components/PricingCard";

// Pricing: School/Institute pays per evaluation — ₹2 per 10 marks, per
// student (e.g. a 50-mark paper for 500 students = 5 × 2 × 500 = ₹5,000).
function PricingSection() {
  const { t } = useTranslation("marketing");

  const teacherFeatures = [
    { label: t("pricing.free.features.f1"), included: true },
    { label: t("pricing.free.features.f2"), included: true },
    { label: t("pricing.free.features.f3"), included: true },
    { label: t("pricing.free.features.f4"), included: true },
    { label: t("pricing.free.features.f5"), included: false },
    { label: t("pricing.free.features.f6"), included: false },
    { label: t("pricing.free.features.f7"), included: false },
  ];

  const schoolFeatures = [
    { label: t("pricing.school.features.f1"), included: true },
    { label: t("pricing.school.features.f2"), included: true, note: "*" },
    { label: t("pricing.school.features.f8"), included: true },
    { label: t("pricing.school.features.f9"), included: true },
    { label: t("pricing.school.features.f3"), included: true },
    { label: t("pricing.school.features.f4"), included: true },
    { label: t("pricing.school.features.f5"), included: true },
    { label: t("pricing.school.features.f6"), included: true },
    { label: t("pricing.school.features.f7"), included: true },
  ];

  return (
    <section className="ul-section ul-pricing-section" id="pricing">
      <div className="ul-center" style={{ marginBottom: 52 }}>
        <SectionLabel>{t("pricing.label")}</SectionLabel>
        <h2 className="ul-section-title">{t("pricing.title")}</h2>
        <p className="ul-section-sub">
          {t("pricing.sub")}
        </p>
      </div>
      <div className="ul-pricing-grid">
        <PricingCard
          plan={t("pricing.free.plan")}
          forWhom={t("pricing.free.forWhom")}
          price="0"
          period={t("pricing.free.period")}
          features={teacherFeatures}
          cta={
            <Link to="/teacher-login" className="ul-pricing-cta-btn outline">
              {t("pricing.free.cta")}
            </Link>
          }
        />

        <PricingCard
          plan={t("pricing.school.plan")}
          forWhom={t("pricing.school.forWhom")}
          price="2"
          suffix={t("pricing.school.suffix")}
          period={t("pricing.school.period")}
          features={schoolFeatures}
          featured
          badge={t("pricing.school.badge")}
          cta={
            <Link to="/request-demo" className="ul-pricing-cta-btn primary">
              {t("pricing.school.cta")}
            </Link>
          }
        />
      </div>
      <div className="ul-pricing-note">
        <Trans t={t} i18nKey="pricing.note" />
      </div>
      <div className="ul-pricing-footnote">{t("pricing.footnote")}</div>
    </section>
  );
}

export default PricingSection;
